import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.unsplash.com',
    headers: {
        Authorization: 'Client-ID 2059cebf171bac3915e14d1caf51c1981560f0fa0af71797c0e4675a5faac2f7'
    }
});